export default __webpack_public_path__ + "static/media/t_wdt_c_4.c9fea38a.mp3";